export type VuexFormActionNameList = "";
export type VuexFormActionNames = {
  [T in VuexFormActionNameList]?: string;
};

export type VuexFormMutationNameList = "UPDATE_FORM";
export type VuexFormMutationNames = {
  [T in VuexFormMutationNameList]?: string;
};

export const VUEX_FORM_NAMESPACE = "form";

export const VUEX_FORM_ACTION_NAMES: VuexFormActionNames = {};

export const VUEX_FORM_MUTATION_NAMES: VuexFormMutationNames = {
  UPDATE_FORM: "update_form"
};
